import type { FC } from "react";
import { Layout, theme } from "antd";
import LanguageSwitcher from "src/components/common/LanguageSwitcher";
import DropDownProfile from "src/components/reusable/DropDownProfile";
import NotificationBell from "src/components/reusable/NotificationBell";
import SmartSearch from "src/components/reusable/SmartSearch";
import { useMenu } from "src/contexts/MenuContext";
import PageBreadcrumb from "./PageBreadcrumb";

const { Header } = Layout;

const HomepageHeader: FC = () => {
  const { setSelectedMenuItem } = useMenu();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Header
      className="header-dashboard d-flex justify-content-between"
      style={{ background: colorBgContainer }}
    >
      <div className="headline">
        <PageBreadcrumb />
      </div>

      {/*
        `pe-3` is Bootstrap's padding-end utility, but this project loads the
        plain LTR-compiled `bootstrap.min.css` (see SourceConnector modals),
        not the `bootstrap.rtl.min.css` build — so `pe-3` compiles down to a
        literal `padding-right`, not a real logical property. Under RTL that
        padding stays on the physical right while the avatar ends up flush
        against the now-exposed physical left with no spacing at all. The
        inline `paddingInlineEnd` below is real CSS, so it actually flips.
      */}
      <div className="pe-3 d-flex align-items-center" style={{ paddingInlineEnd: "16px" }}>
        <div
          style={{
            flex: 1,
            maxWidth: "400px",
            paddingBottom: "20px",
            paddingInlineEnd: "30px",
          }}
        >
          <SmartSearch setSelectedMenuItem={setSelectedMenuItem} />
        </div>

        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <div className="header-language-switcher">
            <LanguageSwitcher />
          </div>
          <NotificationBell />
          <DropDownProfile userType="user" />
        </div>
      </div>
    </Header>
  );
};

export default HomepageHeader;
